import { render, staticRenderFns } from "./employee-reset-password.vue?vue&type=template&id=7fcf9510&scoped=true"
import script from "./employee-reset-password.vue?vue&type=script&lang=js"
export * from "./employee-reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf9510",
  null
  
)

export default component.exports